<script>
import {mapState} from 'vuex'
import FullCalendar from '@fullcalendar/vue'
import FullCalendarHandler from "../../../common/mixins/FullCalendarHandler.vue";

export default {
    name: 'DeadlinesFullCalendar',

    components: {
        FullCalendar,
    },

    mixins: [FullCalendarHandler],

    data() {
        return {
            deadlines: [],
            todos: [],
            bankHolidays: [],
            absences: [],
            meta: [],
            showCalendar: true,
            loading: false,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            clientsActivationFilter: (state) => state.browsing.clientsActivationFilter
        }),

        iCalendarUrl() {
            return `${
                document.head.querySelector('meta[name="base-url"]').content
            }/i-calendar/${this.meta.accountingFirmUuid}/collaborateur/${
                this.meta.accountingFirmUserUuid
            }`
        },
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'deadlines')
    },

    methods: {
        goTo(customData) {
            this.$store.commit('browsing/SET_YEAR', customData.year)
            this.$store.commit('reportingVM/SET_SEARCH', customData.client_name)
            window.location.href = customData.url
        },

        async getItems() {
            if (this.filters.accountingFirmUser > 0) {
                // this.calendarOptions.events = []
                try {
                    this.loading = true
                    const response = await axios.get(
                        `/reporting/calendar/${this.year}/${this.month}/${this.filters.accountingFirmUser}`
                    )
                    this.deadlines = response.data.data.deadlines.data
                    this.todos = response.data.data.todos.data
                    this.bankHolidays = response.data.data.bankHolidays.data
                    this.absences = response.data.data.absences.data
                    this.setEvents()
                    this.meta = response.data.meta
                    this.loading = false
                } catch (error) {
                    console.log(error)
                    this.handleErrors(error.response)
                }
            } else {
                this.showCalendar = false
                this.calendarOptions.events = []
            }
        },

        setEvents() {
            if (this.clientsActivationFilter === 'all') {
                this.calendarOptions.events = this.todos.concat(this.deadlines.concat(this.absences.concat(this.bankHolidays)))
            } else {
                const filteredDeadlines = this.deadlines.filter(
                    (item) => item.activation === this.clientsActivationFilter
                )
                const filteredTodos = this.todos.filter(
                    (item) => item.activation === this.clientsActivationFilter
                )
                this.calendarOptions.events = this.bankHolidays.concat(this.absences.concat(filteredDeadlines.concat(filteredTodos)))
            }
        },

        handleErrors(errorResponse) {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },
    },

}
</script>

<template>
    <div class="w-100">

        <div>
            <div v-if="!showCalendar">
                <b-alert variant="warning" show>
                    Vous devez sélectionner un collaborateur pour afficher son
                    calendrier d'échéances
                </b-alert>
            </div>
            <div v-else>
                <full-calendar ref="myFullCalendar" :options="calendarOptions"/>
                <b-alert
                    variant="primary"
                    :show="showCalendar"
                    class="mt-4 mb-0 shadow"
                >
                    <h4>Abonnement au calendrier :</h4>
                    <p>
                        Vous pouvez vous abonner à ce calendrier en utilisant le
                        lien suivant. Ce lien fonctionne avec l'application
                        Outlook, Microsoft 365, Google calendar ainsi que le
                        calendrier Apple.
                    </p>
                    <p class="mb-0 font-weight-bold">
                        {{ iCalendarUrl }}
                    </p>
                </b-alert>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
